// Doit rester en ligne : via <img src="/logo.svg">, une image en cache garde l'horloge de son
// animation, déjà terminée au rechargement. Styles `.logo-anime*` dans app/workspace.css.
const LAMES = [
  'M63.20 91.97 L63.20 42.38',
  'M20.25 82.42 L63.20 57.62',
  'M7.05 40.44 L50.00 65.24',
  'M36.80 8.03 L36.80 57.62',
  'M79.75 17.58 L36.80 42.38',
  'M92.95 59.56 L50.00 34.76',
];

export default function AnimatedLogo({ className }) {
  return (
    <svg viewBox="0 0 100 100" fill="none" overflow="visible" className={className} aria-hidden="true">
      <circle
        className="logo-anime__anneau"
        cx="50"
        cy="50"
        r="44"
        stroke="currentColor"
        strokeWidth="1.86"
        opacity="0.55"
      />
      <g className="logo-anime__lames" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        {LAMES.map((d, index) => (
          <path
            key={d}
            className="logo-anime__lame"
            style={{ animationDelay: `calc(${0.33 + index * 0.066}s * var(--logo-pace, 1))` }}
            d={d}
          />
        ))}
      </g>
      <polygon
        className="logo-anime__coeur"
        points="60.86,56.27 50.00,62.54 39.14,56.27 39.14,43.73 50.00,37.46 60.86,43.73"
        fill="currentColor"
      />
    </svg>
  );
}
